import React from 'react';

import { useEffect, useRef } from 'react';

export type UserContentProps = React.HTMLAttributes<HTMLDivElement> & {
  text?: string;
  html?: string;
  element?: HTMLElement | null;
};

export const UserContent = ({
  text,
  html,
  element,
  ...otherProps
}: UserContentProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && element) {
      containerRef.current.append(element);
    }
    return () => {
      element?.remove();
    };
  }, [element]);

  return (
    <div
      ref={containerRef}
      {...otherProps}
      dangerouslySetInnerHTML={html ? {__html: html} : undefined}
    >
      {text}
    </div>
  );
};
